export default __webpack_public_path__ + "static/media/rails.9c1e7835.png";